import { render, staticRenderFns } from "./systemNotify.vue?vue&type=template&id=742bffbb&scoped=true&"
import script from "./systemNotify.vue?vue&type=script&lang=js&"
export * from "./systemNotify.vue?vue&type=script&lang=js&"
import style0 from "./systemNotify.vue?vue&type=style&index=0&id=742bffbb&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742bffbb",
  null
  
)

export default component.exports